export const SET_LINK_TYPE = 'SET_LINK_TYPE'
export const SET_LINK_METRIC = 'SET_LINK_METRIC'
export const SET_LINK_DATASETS = 'SET_LINK_DATASETS'
